import { useRequestsBase } from './useRequestsBase'

export function useMyCompleteRequests() {
  return useRequestsBase({
    topLevelFilter: 'mineCompleted',
  })
}
